export const UPDATE_AI_ESTIMATE = `
  mutation UpdateAIEstimate(
    $workloadId: ID!
    $estimateType: String!
    $estimateDollar: String
    $estimateInputTokens: String
    $estimateOutputTokens: String
    $estimateCacheReadTokens: String
  ) {
    updateAIEstimate(
      workloadId: $workloadId
      estimateType: $estimateType
      estimateDollar: $estimateDollar
      estimateInputTokens: $estimateInputTokens
      estimateOutputTokens: $estimateOutputTokens
      estimateCacheReadTokens: $estimateCacheReadTokens
    ) {
      workloadId
      estimateType
      estimateDollar
      estimateInputTokens
      estimateOutputTokens
      estimateCacheReadTokens
      estimateSetAt
      estimateSetBy
    }
  }
`
